import FulfillmentSettings from "./FulfillmentSettings";

const RestaurantSettings = (props) => (
  <FulfillmentSettings kind="restaurant" {...props} />
);

export default RestaurantSettings;
